import { FormattedMessage } from 'react-intl';
import cx from 'classnames';
import { Container } from '@plone/components';
import { useLiveData } from '@kitconcept/volto-light-theme/helpers/useLiveData';
import type { PloneGobrSocialMediaSettings } from '@kitconcept/volto-light-theme/types';
import type { Content } from '@plone/types';
import SlotRenderer from '@plone/volto/components/theme/SlotRenderer/SlotRenderer';

const SocialNetworksSlot = ({ content }: { content: Content }) => {
  const social_links = useLiveData<
    PloneGobrSocialMediaSettings['social_links']
  >(content, 'plonegovbr.socialmedia.settings', 'social_links');

  return content ? (
    <Container className={cx('follow-us')}>
      {social_links?.length > 0 && (
        <div className="follow-us">
          <span>
            <FormattedMessage
              id="Redes Sociais"
              defaultMessage="Redes Sociais"
            />
          </span>
          <SlotRenderer name="followUs" content={content} />
        </div>
      )}
    </Container>
  ) : null;
};

export default SocialNetworksSlot;
